import React from 'react'
import ReactToPrint from "react-to-print";
import companylogo from "../../assets/company.png"

const DamageItemRec = (props) => {
    const componentRef = React.createRef();
    return (
        <>
            <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200">
                <ReactToPrint
                    trigger={() => (
                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                            Print / Download
                        </button>
                    )}
                    content={() => componentRef.current}
                />

                <div ref={componentRef} className="bg-white p-6 relative min-h-[1050px]">
                    <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                        <div>

                            <img  src={companylogo} alt="logo" />
                        </div>
                    </div>

                    <div className="border flex flex-col justify-center items-center border-gray-300 p-4 mb-4">
                        <h1 className='uppercase font-bold text-[20px]'>Damaged Item Record</h1>
                    </div>

                    <div className="relative overflow-x-auto">
                        <table className="w-full text-left rtl:text-right border-black border-[2px]">
                            <thead className="text-md text-black border-black border-[2px] uppercase bg-white">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        Item name
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        QTY
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody className='text-sm'>
                                <tr className=" text-center bg-white">
                                    <th scope="row" className="px-6 py-4 font-medium text-black whitespace-nowrap">
                                        {props.itemname||"Apple MacBook Pro 17"}
                                    </th>
                                    <td className="px-6 py-4">
                                        {props.quantity||"5"}
                                    </td>
                                    <td className="px-6 py-4">
                                        {props.date||"2020-03-04"}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <footer className="absolute bottom-0 left-0 right-0 footer border-gray-300 pb-5">
                        <div className="w-full flex justify-evenly pt-4 pb-14 px-5 border-b border-gray-300 mb-2 text-base">
                            <p className='uppercase font-bold'>Accountant</p>
                            <p className='uppercase font-bold'>Authorised By</p>
                            <p className='uppercase font-bold'>Received By</p>
                        </div>
                        <ul className="flex flex-wrap items-center gap-2 justify-center">
                            <li>
                                <span className="font-bold">Email:</span> {"arcoglassqatar@gmail.com"}
                            </li>
                            <li>
                                <span className="font-bold">Tel:</span> {"4460 5198"}<span className="ml-1 font-bold">-Fax:</span> {"4451 7172"}
                            </li>
                            <li>
                                <span className="font-bold">P.O Box:</span> {"40992, Doha-Qatar "}
                            </li>
                        </ul>
                    </footer>
                </div>

            </div>
        </>
    );
}

export default DamageItemRec